import { Icon, Tag, Text, XStack, YStack } from '@frontend/web-react';

type ThreadLanderProps = {
  setInputMessage: (text: string) => void;
};

export const ThreadLander = ({ setInputMessage }: ThreadLanderProps) => {
  const updateInputMessage = (text: string) => setInputMessage(text);
  return (
    <YStack className="gap-md pt-xl pb-md px-md items-center justify-center">
      <XStack>
        <Icon
          className="p-md border-borderPrimary"
          color="accent"
          enableBackgroundColor
          name="DuckbillLogo"
          rounded
          size="xl"
        />
      </XStack>
      <Text className="italic" type="h1" uppercase>
        Tell us what you want done
      </Text>
      <XStack className="gap-sm flex-wrap items-center justify-center">
        <CaptiveThreadExampleTag label="Schedule a doctors appointment" onPress={updateInputMessage} />
        <CaptiveThreadExampleTag label="Create a travel itinerary" onPress={updateInputMessage} />
        <CaptiveThreadExampleTag label="Find gift ideas for a first birthday" onPress={updateInputMessage} />
      </XStack>
    </YStack>
  );
};

const CaptiveThreadExampleTag = ({ label, onPress }: { label: string; onPress: (text: string) => void }) => (
  <Tag
    className="border-borderPrimary"
    label={label}
    onClick={() => onPress(label)}
    rightIconName="IconArrowDownLeft"
    rightIconSize="md"
    textProps={{ color: 'primary', type: 'p-sm' }}
  />
);
